export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20photography%20of%20diverse%20fashion%20products%20including%20colorful%20sneakers%20designer%20sunglasses%20woven%20bags%20and%20gold%20jewelry%20pieces%20scattered%20artistically%20on%20a%20dark%20slate%20gray%20textured%20surface%2C%20dramatic%20studio%20lighting%20with%20strong%20contrast%20shadows%2C%20luxury%20editorial%20style%2C%20high%20end%20fashion%20photography%2C%20rich%20deep%20colors%20on%20dark%20background&width=1600&height=900&seq=hero-v3&orientation=landscape"
          alt="Superbuy Spreadsheet shopping essentials flat lay"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-4">
            The Ultimate
            <br />
            Superbuy Spreadsheet
            <br />
            Resource
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-xl mb-8 leading-relaxed">
            Discover organized product spreadsheets, buying guides, shipping tutorials, and safe shopping strategies — all in one place.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white text-foreground-950 text-sm font-semibold rounded-full hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              superbuy spreadsheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border-2 border-white/60 text-white text-sm font-semibold rounded-full hover:bg-white/15 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-8 h-12 rounded-full border-2 border-white/40 flex items-start justify-center pt-2">
          <div className="w-1.5 h-3 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}